import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Політика конфіденційності</h2>
            <p><strong>Політика конфіденційності Dreamehome</strong></p>
            <p><strong>Вступ</strong></p>
            <p>ТОВ «Чжуймі Інноваційні Технології (Сучжоу)» та пов’язані з нею компанії (далі – «ми» або «Чжуймі») забезпечують
                роботу «Dreamehome», а також надають Вам платформу (або послуги) для управління та адміністрування
                смарт-обладнанням. Ми чітко розуміємо важливість персональних даних для Вас та докладаємо максимальні зусилля
                для
                забезпечення безпеки Ваших персональних даних. Ми, відповідно до всесвітньо визнаних стандартів безпеки,
                використовуємо надійні заходи для захисту Ваших персональних даних.</p>
            <p>Тому, просимо Вас уважно прочитати та зрозуміти «Політику конфіденційності Dreamehome» перед початком
                використання
                нашої продукції (або послуг).</p>
            <p>Якщо ви не досягли повноліття, просимо використовувати цей додаток лише зі згоди опікуна з відповідними
                положеннями
                політики обслуговування. </p>
            <p>Під час розробки цієї політики конфіденційності ми повністю врахували Ваші потреби та намагалися надати Вам змогу
                повністю зрозуміти принципи збору та використання персональних даних, а також надати Вам можливість контролювати
                ті
                персональні дані, які Ви нам надаєте. Це надзвичайно важливо. Ця політик конфіденційності визначає принципи, за
                якими ми збираємо, використовуємо, розкриваємо, оброблюємо та зберігаємо інформацію, яку Ви надаєте нам під час
                використання нашого додатку. Ми використовуємо зібрані дані в суворій відповідності з цією політикою
                конфіденційності.</p>
            <p>Ця політика конфіденційності допоможе Вам дізнатися про наступне:</p>
            <p>1. Які дані ми збираємо та як їх використовуємо</p>
            <p>2. Як ми використовуємо Cookie та схожі технології</p>
            <p>3. Як ми доручаємо здійснювати обробку, розповсюдження, передачу та публічне розкриття Ваших персональних даних
            </p>
            <p>4. Як ми зберігаємо та захищаємо Ваші персональні дані</p>
            <p>5. Ваші права</p>
            <p>6. Транскордонна передача даних</p>
            <p>7. Як зв’язатися з нами</p>
            <p>8. Як оновлюється ця політика конфіденційності</p>
            <p>Додаток 1: детальна інформація з SDK третіх сторін</p>
            <p>Нашою метою є забезпечення найкращого користувацького досвіду. Якщо у Вас залишилися питання щодо політики
                конфіденційності, в нашій компанії працюють спеціальні департаменти та робітники з обробки конфіденційних даних,
                ви
                можете зв’язатися з ними за допомогою контактних даних в сьомій частині цієї політики конфіденційності. Ми
                надамо
                Вам відповідь відповідно до політики та законодавства відповідних країн. Якщо наша відповідь не задовольняє Вас,
                особливо якщо Ви вважаєте, що наша політика обробки персональних даних завдає шкоди Вашим законним інтересам, ви
                можете подати позов у компетентний суд, подати скаргу у компетентні урядові органи або вирішити це питання
                іншими
                шляхами. </p>
            <p><strong>I. Які дані ми збираємо та як їх використовуємо</strong></p>
            <p>Персональні дані – це різноманітні дані, які записуються в цифровому або іншому вигляді, та які самостійно або
                разом з іншими даними надають змогу ідентифікувати конкретну особу. </p>
            <p>Чутлива персональна інформація може зашкодити безпеці особи або її майна у разі розкриття або незаконного надання
                та використання, завдати шкоди репутації та здоров’я особи, призвести до дискримінації тощо. Така інформація
                включає
                в тому числі номер посвідчення особи, особисті біометричні дані, дані банківського рахунку, інформацію про
                майно,
                історію пересування, торгових операцій, персональні дані дітей, віком до 14 років (включно) тощо.</p>
            <p>Основною метою, з якою ми здійснюємо збір персональних даних, є надання Вам продукції та/або послуг, а також
                забезпечення дотримання відповідного законодавства, нормативно-правових актів тощо. Ви маєте право самостійно
                обирати, чи надавати нам відповідну інформацію, проте в більшості випадків, у разі відмови надання відповідних
                даних, ми не зможемо надавати Вам відповідні послуги та відповідати на Ваші питання.</p>
            <p><strong>（I）Умови збору та обробки Ваших персональних даних під час надання базових послуг Dreamehome</strong></p>
            <p><strong>（1）Під’єднання та керування додатком Dreamehome на смарт-обладнанні</strong></p>
            <p>Послуги, які надає Вам Dreamehome забезпечують Вам безпечне з’єднання зі смарт-пристроями та керування ними. Ми
                можемо збирати дані Вашого Wi-Fi, інформацію про місцезнаходження, дані входу в обліковий запис, дані про
                мобільний
                телефон, смарт-пристрої, а також дані, пов’язані з обліковим записом «Чжуймі», дані про смарт-пристрої. Ця
                інформація використовується для забезпечення швидкого та надійного з’єднання смарт-пристроїв, можливості
                знаходити
                пристрої поблизу та керувати пристроями. Детальний список даних, збір яких здійснюється, зазначений нижче:</p>
            <p>Дані входу в обліковий запис: ім’я користувача, пароль, нікнейм, фото профілю, електронна пошта, номер мобільного
                телефону Вашого облікового запису «Чжуймі». В свою чергу ім’я користувача, пароль, номер мобільного телефону та
                електронна пошта належать до чутливих персональних даних, метою збору таких даних є ідентифікація особи
                користувача
                облікового запису «Чжуймі» та отримання даних прав доступу до серверу Dreamehome. Введені Вами ім’я користувача
                та
                пароль для входу в обліковий запис будуть передані у зашифрованому вигляді на сервер «Чжуймі» для авторизації;
            </p>
            <p>Дані про мобільний телефон: ідентифікатори пристрою (IMEI/OAID, МАС-адреса, Android ID), модель мобільного
                телефону, інформація про версію системи, мову системи, країну та регіон роботи мобільного телефону, розміри та
                роздільну здатність екрану мобільного телефону, дані завантаження ЦПУ та відображення пристроїв. Метою збору
                відповідної інформації є забезпечення можливості з’єднання додатку Dreamehome з смарт-пристроями. </p>
            <p>Дані про смарт-пристрої: ім'я, модель, версія смарт-пристрою, виробник, ідентифікаційний код пристрою,
                МАС-адреса,
                ІР-адреса, стан роботи пристрою, властивості кастомізації, параметри налаштувань, історію подій та журнали
                керування
                та використання пристроїв. Ми збираємо відповідні дані для того, щоб здійснити прив’язку смарт-пристроїв,
                управління
                та адміністрування пристроями, а також налаштування властивостей та параметрів обладнання, отримання даних про
                робочий стан обладнання та історію його роботи.</p>
            <p><strong>（2）Оновлення додатку Dreamehome та смарт-пристроїв:</strong></p>
            <p>Щоб продовжити надавати Вам найновіші послуги Dreamehome, в тому числі послуги з оновлення додатку Dreamehome, ми
                можемо використовувати дані версії Вашого додатку Dreamehome та дані моделі мобільного телефону. Окрім того, ми
                можемо збирати дані списку вже під’єднаних смарт-пристроїв та інформацію про їх версію, щоб виконувати оновлення
                відповідного смарт-обладнання та надання останньої версії нашого сервісу (разом з версією прошивки). Dreamehome
                лише
                надає засоби для оновлення смарт-пристроїв, нові версії прошивки смарт-обладнання надаються виробником
                відповідного
                смарт-обладнання. Саме виробник відповідає за якість версії прошивки та результат оновлення.</p>
            <p>Якщо Ви не надасте відповідні дані, ми не зможемо надати Вам останню версію додатку Dreamehome та прошивки
                смарт-пристроїв. </p>
            <p><strong> (3) Вирішення проблем онлайн:</strong></p>
            <p>Щоб допомогти Вам ефективніше вирішувати проблеми, що виникають під час користування додатком Dreamehome та
                смарт-пристроїв, ми створили спеціальний канал для вирішення проблем онлайн. Для цього нам необхідно збирати
                наступні Ваші дані: дані журналів роботи додатку Dreamehome та обладнання, Ваші контактні дані та опис проблеми,
                фото- та відео-підтвердження проблеми. Дані журналів додатку та обладнання можуть включати інформацію про стан
                пристроїв, дані датчиків, історію операцій обладнання, ідентифікатори пристроїв тощо. Метою збору таких даних є
                аналіз та визначення причин відповідних проблем. Ми збираємо Ваші контактні дані, щоб мати змогу забезпечити
                зворотний зв’язок, дізнатися, чи були вирішені відповідні проблеми, або зв’язатися з Вами. Сподіваємося, що Ви
                надасте необхідні дані. </p>
            <p>Ми використовуємо Ваші персональні дані наступними шляхами: лише для визначення та вирішення питань та скарг, ми
                не
                розкриваємо Ваші персональні дані та не передаємо такі дані для розповсюдження реклами. Якщо Ви не надасте
                відповідні дані, ми не зможемо ефективно визначити та вирішити проблеми, з якими Ви до нас звертаєтеся. </p>
            <p><strong>(II) Коли ми збираємо та обробляємо Ваші персональні дані, які не стосуються базових послуг
                Dreamehome</strong></p>
            <p>Окрім персональних даних, які ми використовуємо для надання базових послуг Dreamehome, ми також можемо збирати та
                використовувати Ваші персональні дані для забезпечення роботи додаткових функцій, зазначених нижче. У разі
                відмови
                надати відповідні персональні дані, Ви все одно зможете скористатися базовими послугами Dreamehome, але не
                матиме
                доступу до додаткових функцій, які можуть принести Вам користь. Ці додаткові функції включають:</p>
            <p><strong>План підвищення рівня користувацького досвіду:</strong></p>
            <p>Щоб покращити користувацький досвід, нам необхідно збирати наступну інформацію: журнали роботи Dreamehome, в тому
                числі зашифрований журнал ключових операцій, журнал подій, журнал несправностей, операційні події, дані
                використання
                різноманітних інтерфейсів додатку. У відповідні журнали не вноситься Ваші чутливі дані.</p>
            <p>Ми використовуємо персональні дані наступними шляхами: ми здійснюємо автоматичний збір зазначеної інформації та
                передаємо її на сервер, аналізуємо дані журналів для діагностики стану роботи пристроїв та аналізу даних
                використання додатку. </p>
            <p>Якщо Ви не надасте відповідну інформацію, Dreamehome не зможе покращити Ваш користувацький досвід, проте це не
                вплине на роботу базових функцій додатку.</p>
            <p> <strong>(III) Умови отримання Ваших персональних даних від третіх сторін</strong></p>
            <p>Якщо це дозволяє місцеве законодавство, ми в деяких випадках можемо отримувати Ваші персональні дані від третіх
                сторін. Наприклад:</p>
            <p>1. З Вашої згоди під час управління смарт-пристроями третіх осіб Ми будемо співпрацювати з сторонніми
                провайдерами
                послуг. Така співпраця може мати відношення до Ваших персональних даних, які ми отримуємо від сторонніх
                провайдерів
                послуг. Здійснюючи управління обладнаннями третіх сторін ми будемо отримувати Ваші наступні персональні дані, за
                умовою прив’язки до стороннього облікового запису:</p>
            <p>Дані сторонніх облікових записів, включаючи Ваш нікнейм, фото профілю для відображення в додатку Dreamehome;</p>
            <p>Дані обладнання та мережеві дані, включаючи ідентифікатори обладнання, МАС-адреса, серійний номер пристрою, які
                використовується для ідентифікації робочих пристроїв та управління безпекою пристроїв. </p>
            <p>Якщо для надання послуг мі зіткнемося з необхідністю здійснювати операції з обробки персональних даних, які
                виходять за межі повноважень, погоджені Вами під час передачі Ваших персональних даних стороннім провайдерам
                послуг,
                ми, перше ніж виконувати обробку відповідних даних, запросимо Вашої чіткої згоди. Окрім того, ми чітко
                дотримуємося
                відповідних положень законодавства та вимагаємо від сторонніх провайдерів послуг підтверджувати законність
                даних,
                які вони надають. </p>
            <p><strong>（IV）Неперсональні дані</strong></p>
            <p>Ми також можемо збирати інші дані, за допомогою яких неможливо ідентифікувати конкретну особу (тобто
                неперсональні
                дані), наприклад статичні дані, отримані під час користування Вами конкретними послугами – дані про дії
                користувача
                (включаючи дані про кліки, перегортання сторінок, час перегляду). Метою збору таких даних є покращення якості
                послуг, які ми надаємо Вам. Типи та кількість зібраних даних залежать від того, Як ви користуєтеся нашою
                продукцію
                та/або послугами. Ми систематизуємо такі дані та використовуємо для того, щоб надавати більш корисну інформацію
                нашим клієнтам, зрозуміти найбільш цікаві продукти та послуги для клієнта, оптимізувати наші сервіси. В рамках
                цієї
                політики конфіденційності зведені дані вважаються неперсональними даними. Якщо ми використовуємо неперсональні
                дані
                разом з персональними, то з моменту їх поєднання такі дані починають вважатися персональними.</p>
            <p><strong>II. Як ми використовуємо Cookie та схожі технології</strong></p>
            <p>Щоб забезпечити нормальну роботу Dreamehome, ми можемо зберігати невеликі файлі даних на вашому пристрої, які
                називаються Cookie. Cookie зазвичай містять ідентифікатори, заголовки веб-сторінок та деякі числові та текстові
                значення. Завдяки Cookie додаток Dreamehome отримує можливість зберігати облікові дані веб-сайтів, дані про Ваші
                вподобання тощо.</p>
            <p>Ми не використовуємо Cookie для будь-яких цілей, окрім зазначених вище. Ви можете на свій розсуд керувати або
                видаляти Cookie. Проте, в такому разі, в деяких випадках це може поставити під загрозу Вашу безпеку під час
                використання Dreamehome, а також призведе до необхідності самостійно змінювати користувацькі налаштування під
                час
                кожного використання Dreamehome.</p>
            <p><strong>III. Як ми доручаємо обробку, розповсюдження, передачу та публічне розкриття Ваших персональних
                даних?</strong></p>
            <p><strong>（I）Доручення операцій з обробки даних</strong></p>
            <p>Як правило «Чжуймі» може доручити іншим компаніям здійснювати обробку Ваших персональних даних від нашого імені.
                Наприклад від нашого імені зв'язуватися з Вами, відправляти електронні листи або надавати Вам технічну
                підтримку.
                Такі компанії можуть використовувати Ваші персональні дані лише для того, щоб надавати Вам послуги від нашого
                імені.
            </p>
            <p>Ми підпишемо з нашими довіреними сторонами сувору угоду про конфіденційність або положення з обробки персональних
                даних та вимагатиме від них здійснювати обробку персональних даних відповідно до цієї політики конфіденційності
                та
                вживати заходи для забезпечення конфіденційності та безпеки Ваших персональних даних.</p>
            <p><strong>（II）Розповсюдження даних</strong></p>
            <p>Зазвичай ми не ділимося Вашими персональними даними з іншими, окрім наступних випадків:</p>
            <p>1. Отримавши Вашу чітку згоду, ми передамо вказаній Вами третій стороні інформацію, яка не виходить за рамки
                Вашого
                дозволу. Це включає передачу даних про Ваші побутові смарт-прилади та їх конфігурацію Вашім друзям для
                забезпечення
                швидкого доступу Ваших друзів до цього програмного забезпечення та послуг за допомогою їх мобільних пристроїв.
            </p>
            <p>2. Частина послуг сервісу Dreamehome надається сторонніми провайдерами послуг. В зв’язку з цим нам необхідно
                надавати частину Ваших персональних даних відповідним стороннім провайдерам послуг, наприклад під час управління
                веб-сторінками, аналізу даних, обробці платежів та даних кредитних карт, обслуговуванні інфраструктури, наданні
                IT-послуг, послуг з підтримки клієнтів, відправки електронних листів та інших аналогічних послуг. Таким чином ми
                гарантуємо здатність сторонніх провайдерів надавати Вам зазначені послуги. </p>
            <p>3. Розкриття Ваших персональних даних клієнтам та іншим партнерам, які прямо або опосередковано надають Вам
                смарт-пристрої та/або доступ до мереж та систем, які Ви використовуєте для доступу та користування нашими
                послугами
                та веб-сайтами. </p>
            <p>4. Надання Ваших персональних даних залежним компаніям або іншим третім сторонам у випадку реструктуризації,
                злиття, продажу, інвестицій, відчуження, передачі або інших операцій з усіма або часткою активів, майна або
                акціонерного капіталу (в тому числі у випадках, пов’язаних з банкрутством або аналогічними процедурами). В таких
                випадках Ви електронною поштою та/або на нашому веб-сайт отримаєте від нас чітке повідомлення про всі зміни
                прав,
                нові методи використання персональних даних та опції, які стосуються персональних даних.</p>
            <p>5. У випадках, коли ми вважаємо це необхідним або доручним: (а) дотримання норм законодавства: (b) дотримання
                юридичних процедур; (с) реагування на вимоги суспільних організацій або урядових органів, включаючи суспільні
                організації та урядові органи в країні/регіоні Вашого проживання; (d) виконання наших положень та умов; (е)
                захист
                наших адміністративних, господарських потреб та систем; (f) захист прав, конфіденційності, безпеки та майна
                нашої
                компанії та/або наших користувачів, включаючи Вас; а також (g) пошук доступних заходів попередження або
                обмеження
                компенсації завданої нами шкоди.</p>
            <p>6. Розкриття Ваших персональних даних дочірнім та залежним компаніям для регулярного виконання господарських
                операцій.</p>
            <p>7. Ми ділимося необхідними даними з третіми сторонами за допомогою програмного інтерфейсу додатку (API) та пакету
                розробника програмних інструментів (SDK), версії SDK різних третіх сторін можуть відрізнятися, та зазвичай
                поділяються на такі типи: облікові дані сторонніх облікових записів, надання загального доступу до даних,
                платежі
                третім сторонам, реклама компаній, статистичні дані тощо. Ми проводимо суворий контроль безпеки третіх сторін та
                вживаємо заходи для захисту даних. В Додатку 1 надана детальна інформація про SDK авторизованих нами третіх
                сторін,
                будь ласка, уважно прочитайте Додаток 1. Наша політика конфіденційності не розповсюджуються на продукцію та
                послуги,
                які надаються третіми сторонами. Під час користування Вами відповідною продукцію та послугами, може
                здійснюватися
                збір Ваших даних. Тому ми наполегливо рекомендуємо Вам прочитати політику конфіденційності третіх сторін, так
                само
                як і нашу політику конфіденційності. Ми не несемо відповідальності за те, як треті сторони використовують
                зібрані
                персональні дані та не можемо контролювати їх використання. Наша політика конфіденційності не стосується інших
                веб-сторінок, пов’язаних з нашими послугами. Перш ніж Ви вперше перейдете на сторонню сторінку, сторонній
                провайдер
                послуг запропонує Вам прочитати відповідну угоду та заяву про конфіденційність. Уважно прочитайте цю угоду та
                заяву
                про конфіденційність.</p>
            <p><strong>（III）Передача</strong></p>
            <p> «Чжуймі» не передає Ваші персональні дані будь-яким компаніям, організаціям та особам, окрім наступних випадків:
            </p>
            <p>1. Передача за умови отримання згоди: отримавши Вашу чітку згоду, ми можемо передавати Ваші персональні дані
                іншим
                сторонам;</p>
            <p>2. Якщо процедури злиття, купівлі або ліквідації компанії унаслідок банкрутства мають відношення до передачі
                персональних даних, ми вимагатиме від компанії чи організації, яка отримує доступ до Ваших персональних даних,
                продовжувати дотримуватися положень цієї політики конфіденційності або запросити Вашу згоду на надання
                відповідного
                доступу.</p>
            <p><strong>（IV）Публічне розкриття</strong></p>
            <p>Ми можемо публічно розкривати Ваші персональні дані у наступних випадках:</p>
            <p>1. Отримавши Ваші чітку згоду;</p>
            <p>2. Розкриття на законних підставах: ми можемо оприлюднити Ваші персональні дані за умови відповідності
                законодавству або законним процедурам, в рамках розглядання судового позову або якщо цього вимагає в примусовому
                порядку урядові компетентні органи. </p>
            <p><strong>IV. Як ми зберігаємо та захищаємо Ваші персональні дані</strong></p>
            <p>Ми зберігаємо персональні дані протягом періоду, необхідного для збору інформації, вказаної в цій політиці
                конфіденційності, або відповідно до чинних законодавчих вимог. Після досягнення мети збору даних, або після
                того, як
                ми підтвердимо вашу заявку на видалення відповідних даних, або після того, як ми припинимо роботу відповідного
                продукту чи послуги, ми припинимо зберігати вказані дані та видалимо або анонімізуємо її. Якщо збір даних
                здійснюється з суспільних інтересів, для проведення наукових, історичних або статистичних досліджень, ми
                продовжуватимемо зберігати відповідні дані відповідно до чинного законодавства, навіть якщо подальша обробка
                даних
                не має нічого спільного з початковою метою збору.</p>
            <p>Час зберігання Ваших персональних даних при використанні Dreamehome:</p>
            <p>Що стосується даних, які зберігаються локально у додатку Dreamehome, то у разі видалення Вами додатку Dreamehome
                або даних додатку Dreamehome, усі дані, що зберігалися, також будуть видалені. </p>
            <p>Усі операційні дані та дані смарт-пристроїв Dreamehome, які зберігаються на сервері, будуть негайно видалені
                після
                того, як ви видалите смарт-пристрої, відхилите політику конфіденційності Dreamehome та припините користування
                послугами Dreamehome. </p>
            <p>Ми нерегулярно здійснюємо видалення даних серверу, які стосуються даних операційних журналів, статистичних даних
                та
                історії. Період зберігання даних зазвичай не перевищує 2 роки.</p>
            <p>Окрім того, у випадку припинення надання нашої продукції або послуг ми відправимо push-повідомлення та видалимо
                Ваші персональні дані або виконаємо їх анонімізацію протягом справедливого періоду часу. </p>
            <p><strong>V. Ваші права</strong></p>
            <p><strong> (I) Перегляд, виправлення та видалення Ваших персональних даних</strong></p>
            <p>Відповідно до чинного законодавства Вашої країни або регіону Ви маєте право вимагати перегляд, виправлення,
                видалення будь-яких Ваших персональних даних, які ми зберігаємо (далі скорочено – запит). Відправте листа або
                зв’яжіться з нами за допомогою Dreamehome. Законодавство більшості країн визначає особливі вимоги, яким повинні
                відповідати запити власників персональних даних. В цій політиці визначаються наступні вимоги до Ваших запитів:
            </p>
            <p>Запити, які Ви подаєте через наші спеціальні канали для відправки запитів, виходячи з міркувань забезпечення
                безпеки Ваших даних, повинні надаватися у письмовій формі (якщо місцеве законодавство однозначно не визнає
                подання
                усних заяв);</p>
            <p>Надання достатньої інформації дозволить нам підтвердити Вашу особу та гарантувати, що автором запиту є справжній
                власник або законний розпорядник даних;</p>
            <p>Коли ми отримуємо достатньо даних для підтвердження можливості обробки Вашого запиту, ми у встановлений
                законодавством з захисту даних термін надамо відповідь на Ваш запит. А саме:</p>
            <p>Відповідно до Ваших вимог та вимог чинного законодавства, ми можемо безкоштовно надати Вам копію записів Ваших
                персональних даних, які мі зібрали та обробили. Якщо ви надаєте інші запити, що стосуються цієї інформації, ми
                можемо вимагати від Вас сплати справедливої плати відповідно до вимог чинного законодавства та реальних
                адміністративних витрат.</p>
            <p>Якщо Ви вважаєте, що будь-які дані про Вас, якими ми володіємо, є невірними чи не повними, Ви можете вимагати
                виправити або доповнити Ваші персональні дані відповідно до мети їх використання.</p>
            <p>Відповідно до чинного законодавства Вашої країни, Ви маєте право вимагати від нас видалити Ваші персональні дані.
                Ми проводимо оцінку Вашого запиту на видалення даних, та у випадку його відповідності вимогам, вживаємо заходи
                для
                його обробки, включаючи застосування необхідних технічних засобів. Після того як Ви самостійно або з нашою
                допомогою
                видалили відповідні дані, ми можемо не мати змоги негайно видалити відповідні дані з системи резервного
                копіювання
                через вимоги чинного законодавства та техніки безпеки. Ми безпечно зберігаємо Ваші персональні дані та захищаємо
                їх
                від будь-якої подальшої обробки до тих пір, поки резервні копії не можна буде видалити або анонімізувати.
                Наприклад,
                відповідно до «Закону КНР про електронну комерцію» дані про Ваші товари та послуги, торгівельні операції
                зберігаються не менше трьох років зі дня завершення операції.</p>
            <p>Ми маємо право відмовити в обробці несуттєвих/заплутаних повторюваних запитів, запитів, які завдають шкоди
                конфіденційності інших, запитів, виконати які неможливо, запитів на проведення невідповідного об’єму технічних
                робіт, а також запитів, які не є необхідними відповідно до місцевого законодавства, інформації , яка була
                оприлюднена, та даних, що надаються на умовах конфіденційності. Ми також можемо відхилити запит, якщо ми
                вважаємо,
                що певні аспекти запиту на видалення даних або доступу до даних можуть перешкодити нам легально використовувати
                дані
                для вказаних вище цілей боротьби з шахрайством та охорони безпеки.</p>
            <p><strong>(II) Скасування згоди</strong></p>
            <p>Ви можете подати запит на ві Вашої згоду, включаючи згоду на збір, використання та/або розкриття Ваших
                персональних
                даних, якими ми володіємо або які контролюємо. Ви можете виконати цю операцію, використовуючи контактні дані з
                Розділу 7 цієї політики конфіденційності, в залежності від конкретних послуг, якими ви користувалися. Ми
                обробимо
                Ваш запит протягом справедливого періоду часу після його надсилання, а також, в залежності від сутності Вашого
                запиту, припинимо збір, використання та/або розкриття Ваших персональних даних.</p>
            <p>Зверніть увагу, що залежно від рамок вашого дозволу на обробку інформації, відкликання Вашої згоди може призвести
                до того, що Ви не зможете користуватися Dreamehome або відповідними послугами з управління смарт-пристроями.
                Однак
                ваше рішення скасувати свою згоду чи дозвіл не вплине на обробку персональних даних, яка проводилася до цього
                відповідно до Вашого дозволу. </p>
            <p>Ви можете відмовитися від плану покращення користувацького досвіду та відкликати згоду на використання
                відповідних
                персональних даних, подавши запит на скасування згоди або відвідавши сторінку Dreamehome для зміни відповідних
                параметрів,</p>
            <p><strong>(III) Видалення облікового запису Dreamehome</strong></p>
            <p>Ви можете видалити обліковий запис, відвідавши сторінку «Мій профіль» - «Налаштування облікового запису» -
                «Видалити обліковий запис». Якщо ви бажаєте видалити обліковий запис Dreamehome, зауважте, що після видалення
                облікового запису Dreamehome Ви не зможете користуватися Dreamehome та усією лінію продукції та послуг з
                управління
                смарт-пристроями. Ми визначаємо, чи задовольнити Ваш запит на видалення облікового запису, враховуючі Ваші
                законні
                інтереси та законні інтереси інших осіб, а також залежно від обставин використання продукції та послуг з
                управління
                смарт-пристроями Dreamehome.</p>
            <p><strong>VI. Транскордонна передача даних</strong></p>
            <p>Оскільки ми надаємо нашу продукцію та послуги за допомогою ресурсів та серверів, розташованих по всьому світу,
                отримавши Вашу згоду на обробку персональних даних, ми можемо передавати Ваші персональні дані за кордон у
                країну/регіон, в яких надається відповідна продукція та послуги, а також отримувати запити на доступ до
                відповідних
                даних з-за кордону. Заходи захисту даних та інші закони у країнах/регіонах, до яких можуть потрапляти Ваші дані,
                можуть відрізнятися від заходів та законів Вашої країни/регіону. В такому випадку ми вживаємо належні та законні
                засоби відповідно до чинного законодавства усіх країн та регіонів для забезпечення захисту Ваших персональних
                даних.
            </p>
            <p>Особливі зауваження:</p>
            <p>Якщо ви проживаєте в Європейській економічній зоні (EEA), а Ваші персональні дані передаються за межі EEA, ми:
                здійснюємо обробку Ваших персональних даних в регіонах, відносно яких Європейська Комісія встановила, що вони
                мають
                достатній рівень захисту; або застосовуємо належні заходи для захисту Ваших персональних даних, включаючи
                передачу
                даних з використанням належного механізму передачі, наприклад стандартних умов договору Європейської комісії.
            </p>
            <p><strong>VII. Як зв’язатися з нами</strong></p>
            <p>Якщо Ви маєте будь-які питання або зауваження стосовно цієї політики конфіденційності, або Ви маєте будь-які
                запитання стосовно того, як Ми збираємо, використовуємо та розкриваємо Ваші персональні дані, зв’яжіться з нами,
                відвідавши сторінку «Мій профіль» - «Підписка та відгуки» - «Політика конфіденційності». Ми створили спеціальну
                команду, яка вирішує Ваші питання, які стосуються прав з захисту персональних даних, отримання відповідей на
                запитання тощо. Якщо Ваше запитання стосується важливої проблеми, ми можемо вимагати від Вас надати більше
                інформації.Якщо Ви не задовільнені отриманою відповіддю, Ви можете подати скаргу у компетентні органи в Вашій
                країні. У разі отримання Вашого запиту ми відповідно до реальних обставин надамо Вам інформацію про доступні
                шляхи
                подання скарги.</p>
            <p><strong>E-mail:</strong></p>
            <ul>
                <li>Зв’язок в Китаї: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </li>
                <li>Зв’язок з DPO (Сінгапур): <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>Зв’язок з представниками в ЄС：<a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p><strong>Контактний телефон：</strong>400-875-9511</p>
            <p><strong>Веб-сайт: </strong><a className="page"
                href="https://www.dreametech.com">https://www.dreametech.com</a></p>
            <p><strong>VIII. Як ми оновлюємо політику конфіденційності</strong></p>
            <p> «Чжуймі» залишає за собою оновлювати цю політику конфіденційності. У випадку оновлення політики ми запропонуємо
                Вам переглянути змінену політику у спливаючому вікні або іншим наглядним шляхом. Ми будемо здійснювати збір,
                використання та зберігання Ваших персональних даних відповідно до оновленої політики тільки після того, як
                отримаємо
                Вашу згоду. </p>
            <p>Ця політика набуває чинності з дня оновлення.</p>
            <p>Дата останнього оновлення 28 серпня 2021 року</p>
            <p><strong>Додаток 1: детальна інформація про SDK третіх сторін</strong></p>
            <p>*З метою надання біль професійних та безпечних базових та додаткових послуг, Dreamehomeвикористовує сторонні SDK
                продукти. На сьогодні Dreamehome використовує наступні сторонні SDK продукти:</p>
            <div className='tableStyle'>
            <table>
                <tr>
                    <td>
                        <p>Послуги SDK</p>
                    </td>
                    <td>
                        <p>Функція</p>
                    </td>
                    <td>
                        <p>Дані, що збираються</p>
                    </td>
                    <td>
                        <p>Політика конфіденційності третіх сторін</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK статистичного аналізу Umeng</p>
                    </td>
                    <td>
                        <p>Статистичний аналіз</p>
                    </td>
                    <td>
                        <p>Ідентифікатор пристрою (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, SIM-карта, дані IMSI), дані
                            геопозиції</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK відправка push-повідомлень Umeng</p>
                    </td>
                    <td>
                        <p>Відправка push-повідомлень</p>
                    </td>
                    <td>
                        <p>Ідентифікатор пристрою (IMEI/Mac/android /IDFA/OPENUDID/GUID, SIM-карта, дані IMSI), дані геопозиції
                        </p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK соціальних взаємодій Umeng</p>
                    </td>
                    <td>
                        <p>Відкриття доступу третім сторонам</p>
                    </td>
                    <td>
                        <p>Ідентифікатор пристрою (IMEI/Mac/android /IDFA/OPENUDID/GUID, SIM-карта, дані IMSI), дані геопозиції
                        </p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Agora SDK</p>
                    </td>
                    <td>
                        <p>Відтворення голосових конференцій, відеотрансляцій </p>
                    </td>
                    <td>
                        <p>Дані пристрою, стан мережі, дані камери, мікрофону, об’єм пам’яті для запису</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK розсилки Huawei</p>
                    </td>
                    <td>
                        <p>Розсилка</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK розсилки Xiaomi</p>
                    </td>
                    <td>
                        <p>Розсилка</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою, модель пристрою, тип мережі, об’єм пам’яті пристрою, дані прогресу
                            роботи
                            пристрою, версія додатку, версія SDK</p>
                    </td>
                    <td>
                        <p>https://dev.mi.com/console/doc/detail?pId=1822</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK розсилки ОРРО</p>
                    </td>
                    <td>
                        <p>Розсилка</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>SDK розсилки VIVO</p>
                    </td>
                    <td>
                        <p>Розсилка</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>WeChat SDK</p>
                    </td>
                    <td>
                        <p>Вхід за допомогою облікового запису WeChat, репост інформації в WeChat</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою, мережеві дані</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>QQ SDK</p>
                    </td>
                    <td>
                        <p>Репост</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою, мережеві дані</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Weibo SDK</p>
                    </td>
                    <td>
                        <p>Вхід за допомогою облікового запису Weibo, репост інформації в Weibo</p>
                    </td>
                    <td>
                        <p>Дані ідентифікації пристрою, мережеві дані</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>AppleID SDK</p>
                    </td>
                    <td>
                        <p>Використовує Apple ID для входу в обліковий запис</p>
                    </td>
                    <td>
                        <p>Apple ID</p>
                    </td>
                    <td>
                        <p>https://www.Apple.com/legal/privacy/szh/</p>
                    </td>
                </tr>
            </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy